// extracted by mini-css-extract-plugin
export default {"mainContainer":"ReimbursementMethodErrorModal_mainContainer__GEJsP","buttonsContainer":"ReimbursementMethodErrorModal_buttonsContainer__w8j-n"};